// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaesarСipher-message-bar {
  display: grid;
  background: #ffffff;
  border: 0.1vw solid #1a6a7c;
  border-radius: 1.5vw;
  text-align: center;
  place-items: center;
  height: 2.2vw;
  padding: 0.1vw;
  color: #1a6a7c;
  font-size: 1.5vw;
}

.CaesarСipher-top-bar {
  display: grid;
  align-items: center;
  margin: 0 3.4vw;
  grid-template-columns: min-content auto 2.2vw;
  gap: 0.4vw;
}

a.CaesarСipher-logo {
  height: 2.2vw;
  margin-right: 4vw;
}

img.CaesarСipher-logo {
  position: relative;
  bottom: 2.4vw;
  height: 6vw;
}
.CaesarСipher-icon {
  cursor: pointer;
  height: 100%;
  width: 2.2vw;
}
#CaesarСipher-help-icon:active {
  filter: brightness(0.8);
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/CaesarСipher/styles/Caesar%D0%A1ipherTopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".CaesarСipher-message-bar {\n  display: grid;\n  background: #ffffff;\n  border: 0.1vw solid #1a6a7c;\n  border-radius: 1.5vw;\n  text-align: center;\n  place-items: center;\n  height: 2.2vw;\n  padding: 0.1vw;\n  color: #1a6a7c;\n  font-size: 1.5vw;\n}\n\n.CaesarСipher-top-bar {\n  display: grid;\n  align-items: center;\n  margin: 0 3.4vw;\n  grid-template-columns: min-content auto 2.2vw;\n  gap: 0.4vw;\n}\n\na.CaesarСipher-logo {\n  height: 2.2vw;\n  margin-right: 4vw;\n}\n\nimg.CaesarСipher-logo {\n  position: relative;\n  bottom: 2.4vw;\n  height: 6vw;\n}\n.CaesarСipher-icon {\n  cursor: pointer;\n  height: 100%;\n  width: 2.2vw;\n}\n#CaesarСipher-help-icon:active {\n  filter: brightness(0.8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
